import { startCardList, startCardGrid } from './pagination'

document.querySelectorAll('.standard-card-list.card-list-component').forEach(startCardList)
document.querySelectorAll('.standard-card-list.card-grid-component').forEach(startCardGrid)
